import { TabType, ContentType, InnerGroupTypeList } from "../utils/state";
import { classNames } from "../utils/utils";
import { LockClosedIcon } from "../utils/iconFactory";
import { useState } from "react";
import { SubscriptionModal } from "./Modals/SubscriptionModal";
interface TemplateCardProps {
  key: string;
  item: ContentType;
  onClick: () => void;
  isLocked: boolean;
}

export function TemplateCard({key, item, onClick, isLocked}: TemplateCardProps) {
  const [isOpenSubscription, setIsOpenSubscription] = useState(false)
  return (
    <>
      <SubscriptionModal 
          isVisible={isOpenSubscription} 
          onClose={() => setIsOpenSubscription(false)} 
        />
      <div
        id='template-card'
        key={key}
        className={classNames("relative group flex flex-col cursor-pointer rounded-[16px] h-[184px] w-[352px]",
          "p-6 gap-6 bg-backgroundWhite border border-backgroundDarkGray card-drop-shadow",
          "hover:border-primaryActionAltHover card-hover-drop-shadow")}
        onClick={() => {isLocked ? setIsOpenSubscription(true) : onClick()}}
      >
        
        {
          isLocked &&
          <div className="absolute top-8 right-6">
            <LockClosedIcon className="h-6 w-6 text-gray40 fill-current group-hover:animate-wiggle" />
          </div>
        }
        <div id='card-header' className="flex flex-row gap-2 items-center">
          <item.Icon id='card-icon' className={classNames("h-10 w-10", item.iconColor)} />
          <h1 id='card-name' className="text-style-sub1 text-textMain">{item.name}</h1>
        </div>
        <p id='card-description' className="text-style-body2 text-textSecondary">{item.description}</p>
      </div>
    </>
  )
}

interface TemplateCardRowProps {
  index: number;
  item: TabType; 
  setContentType: (contentType: any) => void;
  navigate?: (path: string) => void;
  onClick?: () => void;
  isLocked: boolean;
}

export function TemplateCardRow({index, item, setContentType, navigate, onClick, isLocked}: TemplateCardRowProps) {
  return (
    <div id='tab' className="pb-16">
      <h1 id='tab-displayName' className="pb-4 text-textMain text-style-h3">{item.displayName}</h1>
      <span id='template-card-row' className='flex flex-wrap w-full gap-5'>
        {Array.isArray(item.groupData) ? (
          item.groupData.map((actualItem, idx) => (
            <TemplateCard
              key={`${index}_${idx}`}
              item={actualItem}
              onClick={() => { 
                setContentType({ group: item.componentName, content: actualItem }); 
                if (navigate) navigate('/edit');
                if (onClick) onClick();
              }}
              isLocked={isLocked}
            />
          ))
        ) : (
          // subTab
          Object.keys(item.groupData).map((subTabKey) => (
            <>
              <h2 className="pb-4 text-textMain text-style-sub1">{subTabKey}</h2>
              <div key={`${index}_${subTabKey}`} className="mb-8 flex flex-wrap w-full gap-5">
                {(item.groupData as InnerGroupTypeList)[subTabKey].map((actualItem, idx) => (
                  <TemplateCard
                    key={`${index}_${subTabKey}_${idx}`}
                    item={actualItem}
                    onClick={() => { 
                      setContentType({ group: item.componentName, content: actualItem }); 
                      if (navigate) navigate('/edit');
                      if (onClick) onClick(); 
                    }}
                    isLocked={isLocked}
                  />
                ))}
              </div>
            </>
          ))
        )}
      </span>
    </div>
  )
}